import { CardContent } from '../components/Card/FrontEnd';

const Hand = require('pokersolver').Hand;

export const getHandName = (
  ...cardArgs: (CardContent[] | any | undefined)[]
) => {
  // 合并所有有值的参数
  const cards = cardArgs.flatMap(cards => cards || []);

  if (cards.length === 0) {
    return '';
  }
  const hand = Hand.solve(cards);
  return hand.name;
};
